import comboPositionsTemplate from '../templates/comboPositions.html';

/* @ngInject */
function comboPositionsDirective() {
  return {
    restrict: 'E',
    controller: function () {
      const ctrl = this;
      ctrl.$onInit = function () {
        if (ctrl.onInit) {
          ctrl.onInit({
            posCtrl: ctrl
          });
        }
      };
      ctrl.getActivePosition = function () {
        if (ctrl.positions && ctrl.positions.length > 0) {
          ctrl.activePosition = ctrl.positions.find(pos => pos.Default === true);
          ctrl.activePositionId = ctrl.activePosition.ProductId;
        }
      };
      ctrl.setActivePosition = function (position) {
        ctrl.activePositionId = position.ProductId;
        if (ctrl.onClickPosition) {
          ctrl.onClickPosition({
            position: position
          });
        }
      };
    },
    controllerAs: 'comboPositions',
    bindToController: true,
    scope: {
      positions: '<',
      onClickPosition: '&',
      onInit: '&',
      currencySymbol: '@'
    },
    templateUrl: comboPositionsTemplate,
    link: function (scope, element, attrs, ctrl) {
      ctrl.getActivePosition();
      scope.$watchCollection(() => ctrl.positions, function (newPositions) {
        if (newPositions && newPositions.length > 0) {
          ctrl.getActivePosition();
        }
      });
    }
  };
}
export { comboPositionsDirective };